<template>
  <!-- <div style="display: flex;justify-content: center;align-items: center;height: 100%;margin: 200px 0;">
    <div style="width: 50%;">
      <h4>“广西古籍文库”数字平台是依托广西古籍搜集、整理、研究及出版成果而开发的同步数字平台，集数字化古籍、古籍整理数字出版物、古籍相关音视频及图片等资源于一体，支持在线阅读、快速检索、文图对照等功能，形成数字出版与纸质出版同步推进、相互关联、融合呈现的广西古籍融合出版平台。</h4>
      <div  style="cursor: pointer;text-align:center;margin-top: 20px;" class="downs">点击下载<span style="color: red;" @click="clicks">古壮字输入法</span></div>
    </div>
  </div> -->
  <div class="bg1">
    <div class="ba">
      <el-image :src="img" fit="cover"></el-image>
    </div>
    <div class="ba-flex">
      <div class="first" style="">
        <img :src="require('../../assets/image/index/ss1.png')" alt="">
      </div>
      <div style="font-size: 18px;flex: 1;display: flex;justify-content: center;align-items: center;color: #636161;">
        <div class="text">
          <div>
            古壮字输入法是一款专门针对古壮字的输入工具，收录常见古壮字一万余个，包括方正粗雅宋繁体和宋体两种字体。可以在Windows系统下安装使用，支持Windows 2000及以上版本。通过笔画输入，在Word、WPS等文字编辑软件中实现古壮字录入及显示，同时也能够在主流浏览器中访问“广西古籍文库”数字平台，输入古壮字。
          </div>
          <div style="margin-top:8px">
            古壮字输入法的字库将随着古壮字古籍搜集、整理、研究及出版成果的不断丰富而同步更新，以不断满足社会各界对古壮字输入需求。使用古壮字输入法，您可以轻松地输入和显示古壮字，更好地了解和研究民族文化。
          </div>
          <!-- “广西古籍文库”数字平台是依托广西古籍搜集、整理、研究及出版成果而开发的同步数字平台，集数字化古籍、古籍整理数字出版物、古籍相关音视频及图片等资源于一体，支持在线阅读、快速检索、文图对照等功能，形成数字出版与纸质出版同步推进、相互关联、融合呈现的广西古籍融合出版平台。 -->
        </div>
      </div>
      <div @click="clicks" style="width: 289px;display: flex;align-items: center;justify-content: center;cursor: pointer;">
        <img :src="require('../../assets/image/index/ss3.png')" alt="" style="width: 289px;height:138px">
        <!-- <el-image :src="require('../../assets/image/index/ss3.png')" fit="cover" ></el-image> -->
      </div>
      <div class="tow" style="">
        <!-- <img :src="require('../../assets/image/index/ss2.png')" alt=""> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PortalIndex',

    data() {
      return {
        img: require('../../assets/image/index/image7.png'),
      };
    },

    mounted() {

    },

    methods: {
      clicks() {
        var a = document.createElement('a') // 创建一个<a></a>标签
        a.href = './static/古壮字工具包.zip'
        a.download = '古壮字工具包.zip' // 设置下载文件文件名
        a.style.display = 'none' // 隐藏a标签
        document.body.appendChild(a) // 将a标签追加到文档对象中
        a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove() // 一次性的，用完就删除a标签
      }
    },
  };
</script>

<style lang="less" scoped>
  .bg1 {
    overflow: hidden;

    .ba {
      .el-image {
        width: 100%;
        height: 370px;
      }
    }

    .ba-flex {
      display: flex;
      justify-content: space-between;

      .first {
        img {
          width: 423px;
          height: 226px;
        }

      }

      .tow {
        width: 538px;
        height: 224px;
        background: url('../../assets/image/index/ss2.png') no-repeat;
        background-size: cover;
      }

      .text {
        width: 621px;
        text-indent: 2em;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis; //多出部分用...代替
        display: -webkit-box; //定义为盒子模型显示
        -webkit-line-clamp: 8; //用来限制在一个块元素显示的文本的行数
        -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
      }
    }
  }

  .downs {
    span {
      margin-left: 5px;
    }

    &:hover {
      span {

        text-decoration: underline;
      }
    }
  }

</style>
